export const GET_ABOUT_BEGIN = "GET_ABOUT_BEGIN";
export const GET_ABOUT_SUCCESS = "GET_ABOUT_SUCCESS";
export const GET_ABOUT_ERROR = "GET_ABOUT_ERROR";

export const GET_ABOUT_SINGLE_BEGIN = "GET_ABOUT_SINGLE_BEGIN";
export const GET_ABOUT_SINGLE_SUCCESS = "GET_ABOUT_SINGLE_SUCCESS";
export const GET_ABOUT_SINGLE_ERROR = "GET_ABOUT_SINGLE_ERROR";
